import { Input } from 'components/atoms';
import { FormInput } from 'components/molecules';
import CountrySelectPopupForm from 'components/molecules/popup/country-select/CountrySelectPopupForm';
import LabelFormStep from 'components/templates/label-form-step/LabelFormStep';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useTranslation } from 'react-i18next';
import { useGetCountries } from 'services/enums';
import { CUSTOMER_TYPE, ILabelForm } from 'services/labels/types';
import { getCountries } from 'utils/global/countries.utils';

const LabelBankStep = () => {
  const { t } = useTranslation();
  const formik = useFormikContext<ILabelForm>();
  const { values, status, setFieldValue, errors, submitCount }: IFormikContextType<ILabelForm> =
    useFormikContext<ILabelForm>();

  const countries = useGetCountries();

  return (
    <LabelFormStep
      header={t('label.form.bank.header')}
      description={t('label.form.bank.description')}
    >
      {formik.values.customerType === CUSTOMER_TYPE.Physical ? (
        <FormInput.Text
          name="personalId"
          label={t('input.label.personalId')}
          borderless
          appBackground
          fullWidth
        />
      ) : (
        <FormInput.Text
          name="companyId"
          label={t('input.label.companyId')}
          borderless
          appBackground
          fullWidth
        />
      )}
      <FormInput.Text
        name="bankAccountNumber"
        label={t('input.label.bankAccountNumber')}
        borderless
        appBackground
        fullWidth
      />
      {formik.values.customerType === CUSTOMER_TYPE.Physical ? (
        <CountrySelectPopupForm
          onSelectCountry={(country, actions) => {
            setFieldValue(`personalIdCountryAlfa2`, country.codeAlfa2);
            actions.close();
          }}
          initialCountry={
            countries.data?.find((c) => c.codeAlfa2 === values.personalIdCountryAlfa2) ?? null
          }
          trigger={
            <div className=" w-full cursor-pointer">
              <Input.Text
                name=""
                appBackground
                borderless
                fullWidth
                error={submitCount > 0 ? errors.personalIdCountryAlfa2 : undefined}
                label={t('input.label.country')}
                value={
                  getCountries(countries.data)?.find(
                    (c) => c.value === values.personalIdCountryAlfa2,
                  )?.label ?? ''
                }
                style={{ pointerEvents: 'none' }}
              />
            </div>
          }
        />
      ) : (
        <CountrySelectPopupForm
          onSelectCountry={(country, actions) => {
            setFieldValue(`companyCountryAlfa2`, country.codeAlfa2);
            actions.close();
          }}
          initialCountry={
            countries.data?.find((c) => c.codeAlfa2 === values.companyCountryAlfa2) ?? null
          }
          trigger={
            <div className=" w-full cursor-pointer">
              <Input.Text
                name=""
                borderless
                fullWidth
                appBackground
                error={submitCount > 0 ? errors.companyCountryAlfa2 : undefined}
                label={t('input.label.country')}
                value={
                  getCountries(countries.data)?.find((c) => c.value === values.companyCountryAlfa2)
                    ?.label ?? ''
                }
                style={{ pointerEvents: 'none' }}
              />
            </div>
          }
        />
      )}
      <div className="flex w-full gap-2 ">
        <FormInput.Text
          name="bankName"
          label={t('input.label.bankName')}
          borderless
          appBackground
          fullWidth
        />
        <FormInput.Text
          name="swift"
          label={t('input.label.swift')}
          borderless
          appBackground
          fullWidth
        />
      </div>
    </LabelFormStep>
  );
};

export default LabelBankStep;
